import React from 'react';
import about_us from '../../assests/img/about-us.jpg';

const FeesStructure = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>About Us</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="http://kcmschoolbass.com/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    About Us
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <ul>
                                                    <li className="mb-2 mb-sm-3">
                                                        Fee can be paid either quarterly/half-yearly/yearly. There will be 4 quarterly instalments: 1. April-June; 2. July-September; 3. October-December; 4. January-March.
                                                    </li>
                                                    <li className="mb-2 mb-sm-3">
                                                        On payment of half-yearly dues (by the 15th of May and 15th of November of ongoing academic year) 6% concession will be provided on total tuition fee of the academic year and on payment of yearly dues (by 15th May of ongoing academic year) 10% concession will be provided on total tuition fee of the academic year.
                                                    </li>
                                                    <li className="mb-2 mb-sm-3">
                                                        In case of selection of siblings, 30% tuition fee concession shall be given to the younger sibling. In case of third sibling, 70% tuition fee concession shall be given to the youngest sibling.
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="online-registration" target="_self" className="submenu">
                                                        Online Registration                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="admission-procedure"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Admission Procedure
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="fees-structure" target="_self" className="submenu">
                                                        Fees Structure
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="download-brochure" className="submenu">
                                                        Download Brochure
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div>
                </div>
            </div >
        </>
    )
}

export default FeesStructure;